import {
  CancellationClaimAmount,
  FamilySituation,
  GeographicalArea,
  TripDuration,
  TripType,
  Variant,
} from '@qover-private/protos-web/qover/dojo/travel/v1/terms';

export interface TermsProps {
  cancellationClaimAmount?: CancellationClaimAmount;
  dataShareConsent?: boolean;
  familySituation?: FamilySituation;
  geographicalArea?: GeographicalArea;
  hasAccidentProtection?: boolean;
  hasBaggageProtection?: boolean;
  hasCancellationTrip?: boolean;
  tripDuration?: TripDuration;
  tripType?: TripType;
  variant?: Variant;
}

export class Terms {
  cancellationClaimAmount?: CancellationClaimAmount =
    CancellationClaimAmount.CANCELLATION_CLAIM_AMOUNT_1K;
  dataShareConsent?: boolean = false;
  hasAccidentProtection?: boolean;
  hasBaggageProtection?: boolean = false;
  hasCancellationTrip?: boolean = false;
  familySituation?: FamilySituation;
  tripType?: TripType;
  geographicalArea?: GeographicalArea;
  tripDuration?: TripDuration;
  variant?: Variant;

  constructor(props?: TermsProps) {
    if (props) {
      Object.assign(this, props);
    }
  }

  isMultiTripPremium() {
    return this.variant === Variant.VARIANT_PREMIUM;
  }

  isInEurope() {
    return this.geographicalArea === GeographicalArea.GEOGRAPHICAL_AREA_EUROPE;
  }

  isSingleTrip() {
    return this.tripType === TripType.TRIP_TYPE_SINGLE_TRIP;
  }

  isMultiTrip() {
    return this.tripType === TripType.TRIP_TYPE_MULTI_TRIP;
  }

  isYearTrip() {
    return this.tripType === TripType.TRIP_TYPE_YEAR_TRIP;
  }

  fromSingleTripToYearTrip() {
    this.tripType = TripType.TRIP_TYPE_YEAR_TRIP;
    this.geographicalArea = undefined;
    this.tripDuration = undefined;
  }

  static isSingleTrip(terms: TermsProps) {
    return terms?.tripType === TripType.TRIP_TYPE_SINGLE_TRIP;
  }

  static getCancellationAmountInCents(terms: TermsProps) {
    switch (terms?.cancellationClaimAmount) {
      case CancellationClaimAmount.CANCELLATION_CLAIM_AMOUNT_2_5K:
        return 250000;
      case CancellationClaimAmount.CANCELLATION_CLAIM_AMOUNT_5K:
        return 500000;
      default:
        return 100000;
    }
  }
}
